import Cookies from 'universal-cookie';
import ApplicationEntity from './appEntity';
import { LiveSendCookies, ConsentGDPRCookieValue, TRACKING_TYPES } from './constants';
import { getLinkToken, browserMatch, isNoTrackView, isAcceptView } from './util';

// set default cookie age to 20 years
const DEFAULT_COOKIE_AGE = 20 * 365 * 24 * 60 * 60;
// base on Sean's requirement Yes, this looks good but I would like the cookie expiration to be 90 days.
export const FUNCTIONAL_COOKIE_AGE = 90 * 24 * 60 * 60;

export const STRICTLY_NECESSARY_COOKIE_AGE = 0;

const linkToken = getLinkToken();
const liveSendCookies = new Cookies();
const defaultOption = { secure: true, path: '/', maxAge: DEFAULT_COOKIE_AGE };

const getFullCookieName = (name, withTenant) => {
    if (withTenant && ApplicationEntity.getInstance().tenant) {
        return `${name}-${ApplicationEntity.getInstance().tenant}`;
    }

    return name;
};

export const getCookie = (name, withTenant) => {
    const cookieName = getFullCookieName(name, withTenant);
    return liveSendCookies.get(cookieName);
};

export const removeCookie = (name, option, withTenant) => {
    const cookieName = getFullCookieName(name, withTenant);
    return liveSendCookies.remove(cookieName, option);
};

export const setCookie = (name, value, option, withTenant) => {
    const cookieName = getFullCookieName(name, withTenant);
    liveSendCookies.set(cookieName, value, option);
};

export const deleteCookie = (name, option, withTenant) => {
    const cookieName = getFullCookieName(name, withTenant);
    liveSendCookies.remove(cookieName, option);
};

export const setGDPRCookie = (isWatermarkEnabled = false, value = ConsentGDPRCookieValue.ALL_TRACKING_AND_COOKIES, cookieAge = DEFAULT_COOKIE_AGE) => {
    if (isWatermarkEnabled) {
        setCookie(LiveSendCookies.WATERMARK_CONSENT_GDPR, value, { ...defaultOption, maxAge: cookieAge }, true);
    } else {
        setCookie(LiveSendCookies.CONSENT_GDPR, value, { ...defaultOption, maxAge: cookieAge }, true);
    }
};

export const clearGDPRCookie = () => {
    removeCookie(LiveSendCookies.CONSENT_GDPR, defaultOption, true);
};

export const getGDPRCookie = (isWatermarkEnabled) => {
    if (isWatermarkEnabled) {
        return getCookie(LiveSendCookies.WATERMARK_CONSENT_GDPR, true);
    }

    return getCookie(LiveSendCookies.CONSENT_GDPR, true);
};

export const setLinkPwdCookie = (password) => {
    // there is an obscure bug, IE’s document.cookie will not return a cookie if it was set with a path attribute containing a filename.
    // https://blogs.msdn.microsoft.com/ieinternals/2009/08/20/internet-explorer-cookie-internals-faq/
    if (browserMatch.IE() || browserMatch.Edge()) {
        setCookie(linkToken, window.btoa(password),
            { secure: true, path: '/', maxAge: DEFAULT_COOKIE_AGE });
    } else {
        setCookie(LiveSendCookies.SEISMIC_PREFERENCES, window.btoa(password),
            { secure: true, path: window.location.pathname, maxAge: DEFAULT_COOKIE_AGE });
    }
};

export const getLinkPwdCookie = () => {
    if (browserMatch.IE() || browserMatch.Edge()) {
        return getCookie(linkToken);
    }

    return getCookie(LiveSendCookies.SEISMIC_PREFERENCES);
};

export const setCompliancePwdCookie = (compliancePassword) => {
    setCookie(LiveSendCookies.SEISMIC_COMPLIANCE_PREFERENCES, window.btoa(compliancePassword), defaultOption, true);
};

export const getCompliancePwdCookie = () => getCookie(LiveSendCookies.SEISMIC_COMPLIANCE_PREFERENCES, true);

export const setUniqueInteractionCookie = () => {
    setCookie(LiveSendCookies.UNIQUE_INTERACTION_PROOF, 1, defaultOption, false);
};

export const clearUniqueInteractionCookie = () => {
    removeCookie(LiveSendCookies.UNIQUE_INTERACTION_PROOF, defaultOption, false);
};

export const getUniqueInteractionCookie = () => getCookie(LiveSendCookies.UNIQUE_INTERACTION_PROOF, false);

export const getPasswordFromCookie = (isPasswordRequired, isExpired, isCompliancePasswordRequired) => {
    let password = '';
    let compliancePassword = '';
    // get remembered login infos
    const pwdCookie = getLinkPwdCookie();
    const compliancePwdCookie = getCompliancePwdCookie();

    if (isPasswordRequired && pwdCookie) {
        password = window.atob(pwdCookie);
    } else if (isExpired && isCompliancePasswordRequired && compliancePwdCookie) {
        compliancePassword = window.atob(compliancePwdCookie);
    }

    return { password, compliancePassword };
};

export const getTrackingStatus = (isWatermarkEnabled, isDisabledGDPR, hasCompliancePassword, isFirstLoad = false) => {
    if (isDisabledGDPR) {
        return TRACKING_TYPES.ALL_TRACKING;
    }

    if (isNoTrackView() || isAcceptView()) {
        return TRACKING_TYPES.ALL_TRACKING;
    }

    if (hasCompliancePassword) {
        return TRACKING_TYPES.ALL_TRACKING;
    }

    const gdprCookie = getGDPRCookie(isWatermarkEnabled);

    if (isFirstLoad && !gdprCookie) {
        return TRACKING_TYPES.UNKNOWN;
    }

    if (gdprCookie === ConsentGDPRCookieValue.ALL_TRACKING_AND_COOKIES) {
        return TRACKING_TYPES.ALL_TRACKING;
    } else if (gdprCookie === ConsentGDPRCookieValue.ONLY_FUNCTIONAL_COOKIES) {
        return TRACKING_TYPES.ONLY_FUNCTIONAL;
    }

    return TRACKING_TYPES.STRICTLY_NECESSARY;
};
